/**
 * Broker partner URLs referenced in legal copy and onboarding.
 * Set REACT_APP_BROKER_ICMARKETS_URL in .env for your tracked IC Markets link.
 */
export const FXPRO_OFFICIAL_PARTNER_URL =
  "https://direct-fxpro.com/en/partner/2bDCLQ6wh";

export const FXPRO_CORPORATE_URL = "https://www.fxpro.com/";

export const ICMARKETS_CORPORATE_URL = "https://www.icmarkets.com/";

export function getIcMarketsPartnerUrl() {
  return (process.env.REACT_APP_BROKER_ICMARKETS_URL || "").trim();
}
